import { Tooltip } from '../tooltips/Tooltip'
import Stack, { StackProps } from '@mui/material/Stack'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { ViewModeType } from '@/interfaces/filters'
import { getViewModeHref } from '@/helpers/filters'
import { SpriteIcon } from '@/assets/sprites/SpriteIcon'

interface ViewModeSwitchProps extends StackProps {
  viewMode: ViewModeType
}

export const ViewModeSwitch = ({ viewMode = 'thumbView', ...props }: ViewModeSwitchProps): React.ReactElement => {
  const { asPath } = useRouter()
  const { t } = useTranslation('subheader')

  return (
    <Stack direction="row" alignItems={'center'} spacing={{ xs: 5, sm: 1.5 }} {...props}>
      <Tooltip title={t('switchToThumbnailView')}>
        <Link
          href={getViewModeHref('thumbView', asPath)}
          prefetch={false}
          qa-attribute="viewModeThumbView"
          title={t('switchToThumbnailView')}
          style={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <SpriteIcon spriteId="th-large" color={viewMode === 'thumbView' ? 'primary.main' : 'grey.400'} />
        </Link>
      </Tooltip>
      <Tooltip title={t('switchToListView')}>
        <Link
          href={getViewModeHref('listView', asPath)}
          prefetch={false}
          qa-attribute="viewModeListView"
          title={t('switchToListView')}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <SpriteIcon spriteId="th-list" color={viewMode === 'listView' ? 'primary.main' : 'grey.400'} />
        </Link>
      </Tooltip>
    </Stack>
  )
}
